import React, { PropTypes } from 'react';

import EventSearchResults from './components/EventSearchResults';
import Close from '../Close';

import {
  close,
  expandedInput,
  expandedInputContainer,
  input,
  inputContainer,
} from './styles.module.css';

const EventSearchName = ({
  displayMax,
  events,
  clearQuery,
  fetching,
  onChange,
  onEsc,
  onSelect,
  searchingByName,
  toggleField,
  total,
  value,
}) => (
  <div>
    <div
      className={searchingByName ? expandedInputContainer : inputContainer}
      onFocus={toggleField}
    >
      <input
        id="name"
        name="name"
        type="text"
        autoComplete="off"
        onKeyDown={onEsc}
        className={searchingByName ? expandedInput : input}
        onChange={onChange}
        value={value}
        placeholder="Search for a specific event"
      />
      {value.length > 0 && <Close className={close} onClose={clearQuery} />}
    </div>
    {events && (value.length >= displayMax) &&
      <EventSearchResults
        events={events}
        total={total}
        displayMax={displayMax}
        query={value}
        onSelect={onSelect}
        fetching={fetching}
      />}
  </div>
);

export default EventSearchName;


EventSearchName.propTypes = {
  /**
   * Function to clear input field.
   */
  clearQuery: PropTypes.func,
  /**
   * Number of results to display before 'show all' button.
   */
  displayMax: PropTypes.number,
  /**
   * Whether the searching query is currently fetching
   */
  fetching: PropTypes.bool,
  /**
   * Function called on field change
   */
  onChange: PropTypes.func,
  /**
   * Function that toggles search bar on selecting returned item.
   */
  onSelect: PropTypes.func,
  /**
   * Function to close search on pressing ESC key.
   */
  onEsc: PropTypes.func,
  /**
   * Array of results returned from API.
   */
  events: PropTypes.arrayOf(PropTypes.shape()),
  /**
   * Total number of results returned from API.
   */
  total: PropTypes.number,
  /**
   * Value of input field.
   */
  value: PropTypes.string,
  /**
   *
   */
  searchingByName: PropTypes.bool,
  /**
   *
   */
  toggleField: PropTypes.func,
};

EventSearchName.defaultProps = {
  clearQuery: () => {},
  displayMax: 3,
  fetching: false,
  events: undefined,
  onChange: () => {},
  onSelect: () => {},
  onEsc: () => {},
  searchingByName: false,
  toggleField: () => {},
  total: 0,
  value: '',
};



// WEBPACK FOOTER //
// ./app/src/components/EventSearchName/index.jsx